module.exports = __webpack_public_path__ + "static/media/MN.ce2d7030.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MN.svg
// module id = 2211
// module chunks = 7